import newMessageSoundUrl from './new-message.mp3'

/** URL звука нового сообщения (собирается Vite из assets рядом с чатом). */
export const CHAT_NEW_MESSAGE_SOUND_URL = newMessageSoundUrl
